import { combineReducers } from 'redux';

import campaignDetails from './campaignDetails';
import campaignListings from './campaignListings';

export default combineReducers({
  campaignListings,
  campaignDetails
});
